// AssetManager singleton. Use this to load and access data (images, audio, 3d models,...)

export type AssetGroupMode = 'eager' | 'lazy'

type EagerGroup = Record<string, string>
type LazyGroup = Record<string, () => Promise<string>>

export class AssetManager {
  private static instance: AssetManager // singleton
  private eagerGroups: Record<string, EagerGroup> = {}
  private lazyGroups: Record<string, LazyGroup> = {}

  private constructor() {}

  /**
   * To use the AssetManager we must access it from the getInstance() (even the first time)
   */
  static getInstance(): AssetManager {
    if (!AssetManager.instance) {
      AssetManager.instance = new AssetManager()
    }
    return AssetManager.instance
  }

  /**
   * Register Data
   */
  // registerGroup(
  //   groupName: string,
  //   raw: EagerGroup | LazyGroup,
  //   mode: AssetGroupMode
  // ): void {
  //   if (mode === 'eager') {
  //     const group: EagerGroup = {}

  //     Object.entries(raw as EagerGroup).forEach(([path, url]) => {
  //       const name = path.split('/').pop()!
  //       group[name] = url
  //     })

  //     this.eagerGroups[groupName] = group
  //   }

  //   if (mode === 'lazy') {
  //     const group: LazyGroup = {}

  //     Object.entries(raw as LazyGroup).forEach(([path, loader]) => {
  //       const name = path.split('/').pop()!
  //       group[name] = loader
  //     })

  //     this.lazyGroups[groupName] = group
  //   }
  // }

  registerGroup(
    groupName: string,
    raw: EagerGroup | LazyGroup,
    mode: AssetGroupMode,
    options?: { keepFullPath?: boolean }  // ← new
  ): void {
    if (mode === 'eager') {
      const group: EagerGroup = {}

      Object.entries(raw as EagerGroup).forEach(([path, url]) => {
        const name = options?.keepFullPath ? path : path.split('/').pop()!
        group[name] = url
      })

      this.eagerGroups[groupName] = group
    }

    if (mode === 'lazy') {
      const group: LazyGroup = {}

      Object.entries(raw as LazyGroup).forEach(([path, loader]) => {
        const name = options?.keepFullPath ? path : path.split('/').pop()!
        group[name] = loader
      })

      this.lazyGroups[groupName] = group
    }
  }

  /**
   * Get all keys for a group
   */
  getKeys(group: string): string[] {
    return Object.keys(this.eagerGroups[group] ?? {})
  }

  /**
   * Find a value in a group by predicate over keys
   */
  find(group: string, predicate: (key: string) => boolean): string | undefined {
    const entry = Object.entries(this.eagerGroups[group] ?? {}).find(([key]) => predicate(key))
    return entry?.[1]
  }


  /**
   * Get data
   */
  get(group: string, name: string): string | undefined {
    // synchronous (eager only)
    return this.eagerGroups[group]?.[name]
  }
  async getAsync(group: string, name: string): Promise<string | undefined> {
    // async (lazy only)
    const loader = this.lazyGroups[group]?.[name]
    if (!loader) return undefined
    return await loader()
  }

  /**
   * Make registered AssetManager elements persitent from one page to another
   */
  persist(key: string): void {
    sessionStorage.setItem(key, JSON.stringify(this.eagerGroups))
  }

  restore(key: string): boolean {
    const raw = sessionStorage.getItem(key)
    if (!raw) return false
    this.eagerGroups = JSON.parse(raw)
    return true
  }
}